module.exports = __webpack_public_path__ + "img/landing_box55.d679dc89.jpg";